import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { formatTitleForUrl } from './formatTitleForUrl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const LibraryToExcel = ({ data, fileName }) => {
    const { i18n } = useTranslation();
    const [loading, setloading] = useState(false);

    // Function to remove HTML tags from text
    const stripHtmlTags = (html) => {
        if (!html) return '';
        return html.replace(/<[^>]*>?/g, '').trim();
    };
    const exportExcel = async () => {
        setloading(true);

        // 1. Create a new workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Data Report');
        // if (data.length === 0) {
        //     setloading(true);
        //     return;
        // }

        // 2. Define the table headers
        worksheet.columns = [
            { header: 'Id', key: 'id', width: 10 },
            { header: 'Title', key: 'title', width: 30 },
            { header: 'Description', key: 'description', width: 40 },
            { header: 'Availability', key: 'available', width: 15 },
            { header: 'Link', key: 'link', width: 30 },
            { header: 'image Link', key: 'thumbnail', width: 20 },
            { header: 'Price', key: 'price', width: 20 },
        ];

        // 3. Insert data into the worksheet
        data.forEach((item) => {
            worksheet.addRow({
                id: item.id,
                title: item.title,
                description: stripHtmlTags(item.description),
                available: item.available ? (i18n.language === 'ar' ? 'متوفر' : 'Available') : (i18n.language === 'ar' ? 'غير متوفر' : 'Not Available'),
                link: `https://masar-t.com.sa/${i18n.language}/masarLibrary/${item.id}/${formatTitleForUrl(item.title)}`,
                thumbnail: item.thumbnail,
                price: item.price,
            });
        });

        // 4. Style the header
        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
        });

        // 5. Save the workbook as an Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        setTimeout(() => {
            saveAs(blob, `${fileName}.xlsx`);
            setloading(false);
        }, 4000); // Simulate loading time for better UX

    };

    return (
        <button
            className='btn-masar text-center rounded-2 bg-white my-2 mt-0 fs-3 p-0 c-darkGray col-3 col-sm-1 pt-1'
            onClick={exportExcel}
        >
            {loading ? <span className="excel-loader mt-1"></span> : <FontAwesomeIcon icon={faFileExcel} />}
            {/* <FontAwesomeIcon icon={faFileExcel} /> */}
        </button>
        // {/* <button onClick={exportExcel}>Download Excel</button> */ }
    );
};

export default LibraryToExcel;
